import { FullSample } from '@resistapp/common/types';
import { getSampleChipIds } from '@resistapp/common/utils';

// Scanning every Cq row of a sample is relatively expensive and the research view repeats it for every sample on
// every filter change, so the result is memoized per sample object. Loaded samples are never mutated in the UI:
// every transformation (visibility filtering, dropping unmeasured genes, focusing) creates new sample objects.
const chipIdsBySample = new WeakMap<FullSample, number[]>();

export function getCachedSampleChipIds(sample: FullSample): number[] {
  const cached = chipIdsBySample.get(sample);
  if (cached) {
    return cached;
  }
  const chipIds = getSampleChipIds([sample]);
  chipIdsBySample.set(sample, chipIds);
  return chipIds;
}
